<app-auth-shell title="Sign in" subtitle="Enter your approval desk credentials to continue.">
  <form [formGroup]="form" (ngSubmit)="submit()" class="auth-form">
    <mat-form-field appearance="outline">
      <mat-label>Email</mat-label>
      <input matInput type="email" formControlName="email" autocomplete="username" />
      @if (form.controls.email.invalid && form.controls.email.touched) {
        <mat-error>Enter a valid email address</mat-error>
      }
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Password</mat-label>
      <input
        matInput
        type="password"
        formControlName="password"
        autocomplete="current-password"
      />
      @if (form.controls.password.invalid && form.controls.password.touched) {
        <mat-error>Password is required</mat-error>
      }
    </mat-form-field>

    @if (errorMessage(); as message) {
      <p class="auth-error">{{ message }}</p>
    }

    <button mat-flat-button color="primary" type="submit" [disabled]="loading()" class="auth-submit">
      @if (loading()) {
        <mat-spinner diameter="20" />
      } @else {
        Sign In
      }
    </button>
  </form>
</app-auth-shell>
